//Basic Tree
export const BASIC_TREE = [
    {
      text: "Use the dynamic tree view with checkboxes.",
    },
  ];
  
  export const TREE_VIEW = {
    name: "",
    children: [
      {
        name: "root",
        children: [
          {
            name: "Applications",
            children: [{ name: "Ecommerce" }, { name: "Users" }, { name: "Chat" }],
          },
          {
            name: "Components",
            children: [{ name: "UI-Kits" }, { name: "Bonus-UI" }, { name: "Charts" }],
          },
          {
            name: "Miscellaneous",
            children: [{ name: "Gallery" }, { name: "Blog" }, { name: "Editors" }],
          },
        ],
      },
    ],
  };
  
  //Disabled Trees
  export const DISABLE_TREE = [
    {
      text: "Use the dynamic tree view with checkboxes.",
    },
  ];